<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="currentTab == TABS.PUBLISHING_TAB">
      <img src="@/assets/images/Icon material-notifications-active.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">お知らせ</p>
    </div>
    <div class="d-flex section-title-with-back" v-else-if="currentTab == TABS.VIEWER_TAB">
      <img src="@/assets/images/Icon ionic-md-information-circle_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">お知らせ</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon material-assignment_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">お知らせ管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <!--tab-->
      <ul class="nav nav-tabs" v-if="hasAdminPrivilege">
        <li class="d-flex nav-item" id="inclass_tab_menu">
          <a
            class="nav-link tabitem nav-cursor"
            :class="{ active: currentTab == TABS.PUBLISHING_TAB }"
            @click="selectTab(TABS.PUBLISHING_TAB)"
          >
            掲載中
          </a>
        </li>
        <li class="d-flex nav-item" id="inclass_tab_menu">
          <a
            class="nav-link tabitem nav-cursor"
            :class="{ active: currentTab == TABS.UNPUBLISHED_TAB }"
            @click="selectTab(TABS.UNPUBLISHED_TAB)"
          >
            掲載予定
          </a>
        </li>
        <li class="d-flex nav-item" id="inclass_tab_menu">
          <a
            class="nav-link tabitem nav-cursor"
            :class="{ active: currentTab == TABS.ARCHIVED_TAB }"
            @click="selectTab(TABS.ARCHIVED_TAB)"
          >
            掲載終了
          </a>
        </li>
      </ul>
      <ul class="nav nav-tabs" v-else>
        <li class="d-flex nav-item" id="inclass_tab_menu">
          <a class="nav-link tabitem nav-cursor" :class="{ active: currentTab == TABS.VIEWER_TAB }">
            掲載中
          </a>
        </li>
      </ul>

      <form class="form-inline" v-show="showCreationButton">
        <button type="button" class="btn-sm" @click="createNewNotification">
          新規登録
        </button>
      </form>

      <button
        type="button"
        class="btn btn-gray"
        :class="{ 'btn-gray-with-top': !showCreationButton }"
        @click="displayColumns"
        v-show="hasAdminPrivilege"
      >
        表示項目選択
      </button>
      <div class="form-group float-right">
        <label for="text1">検索:</label>
        <input type="text" id="searchform_small" class="form-control" v-model="filter" />
      </div>

      <form class="form-inline showall">
        <div class="form-sort align-items-center">
          <div class="item-count col-2 my-1">
            <label class="mr-sm-2 sr-only" for="inlineFormCustomSelectSmall">
              Preference
            </label>
            <select class="custom-select mr-sm-2" id="inlineFormCustomSelectSmall" v-model="perPage">
              <option :value="totalNotifications" selected>全</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="150">150</option>
            </select>
            件表示
          </div>
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div :class="{ 'table-wrapper-scroll-y': hasAdminPrivilege }">
            <b-table
              ref="notification-table"
              ::min-width="tableWidth"
              class="sticky-table table-auto-height"
              selectable
              responsive
              sticky-header
              foot-clone
              no-footer-sorting
              :fields="filteredHeaders"
              :filter="filter"
              :filterIncludedFields="searchableFields"
              :per-page="perPage"
              :current-page="currentPage"
              :items="resourcesFiltered"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:cell(title)="row">
                <span v-if="hasAdminPrivilege">
                  {{ row.value }}
                </span>
                <a class="hyper-text" @click="showCurrentNotification(row.item.id)" v-else>
                  {{ row.value }}
                </a>
              </template>

              <template v-slot:cell(importance)="row">
                <span v-if="hasAdminPrivilege">
                  {{ row.value }}
                </span>
                <span v-else>
                  <span class="lb-red" v-if="row.value">{{ row.value }}</span>
                  <span v-else>{{ '―' }}</span>
                </span>
              </template>

              <template v-slot:cell(action)="row">
                <a class="hyper-text" @click="editCurrentNotification(row.item.id)">編集</a>
                <a class="hyper-text hyper-text-right" @click="deleteCurrentNotification(row.item.id)">削除</a>
              </template>

              <template v-slot:foot()="data">
                <div class="footFilters" v-show="data.field.footFilterable">
                  <v-select
                    tag="div"
                    v-model="footFilters[data.column]"
                    placeholder="フィルタ"
                    class="select-control"
                    :options="tableFootOptions[data.column]"
                    :appendToBody="true"
                  />
                </div>
              </template>
            </b-table>
          </div>
          <div class="pagination-footer">
            <label> {{ totalNotifications }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
            <div class="float-right">
              <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
                前
              </button>
              <label class="pagination-border text-center">{{ currentPage }}</label>
              <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">
                次
              </button>
            </div>
          </div>
        </div>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        :show-red-button="!popupTypeCustomHeader"
        red-button-title="削除"
        :green-button-title="popupTypeCustomHeader ? 'OK' : '戻る'"
        @redClick="popupConfirmed"
        @greenClick="popupRejected"
      >
        <template v-slot:header v-if="popupTypeCustomHeader">表示する項目を選択してください</template>
        <template v-slot:header v-else>削除</template>

        <template v-slot:body v-if="popupTypeCustomHeader">
          <thead>
            <tr v-for="field in customHeaders" :key="field.key">
              <th scope="row">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :id="field.key" v-model="field.enable" />
                  <label class="custom-control-label" :for="field.key">
                    {{ field.label }}
                  </label>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:body v-else>
          お知らせ「{{ currentNotification.title }}」を削除しますか？<br />
          削除すると元には戻せませんのでご注意ください。
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import EventBus from '@/helpers/EventBus.js';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateTableHeight, resourcesFiltered, tableFootOptions } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { basicDatetime, basicDate, basicRecipientDisplay } from '@/presenters/fields';

export default {
  components: {
    PopUpHolder,
  },
  data() {
    const TABS = {
      UNPUBLISHED_TAB: 'unpublished_tab',
      PUBLISHING_TAB: 'publishing_tab',
      ARCHIVED_TAB: 'archived_tab',
      VIEWER_TAB: 'viewer_tab',
    };
    let currentTab = TABS.VIEWER_TAB;
    if (this.$store.getters['role/hasAdminPrivilege']) {
      currentTab = TABS.PUBLISHING_TAB;
    }
    var fields = [
      {
        key: 'title',
        label: 'タイトル',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
      },
      {
        key: 'importance',
        label: '重要',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.importanceDisplay(value);
        },
        footFilterable: true,
        footOptions: (value) => {
          return this.importanceDisplay(value);
        },
      },
      {
        key: 'category',
        label: 'カテゴリ',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        footFilterable: true,
      },
      {
        key: 'recipientIds',
        label: '表示先',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.recipientsDisplay(value);
        },
        footFilterable: true,
        footOptions: (value) => {
          return this.recipientsDisplay(value);
        },
      },
    ];
    if (this.$store.getters['role/hasAdminPrivilege']) {
      fields.unshift({
        key: 'postPeriod',
        label: '掲載期間',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (_v1, _v2, item) => {
          return this.postPeriodDatetime(item.startDatetime, item.endDatetime);
        },
      });
      fields.unshift({
        key: 'createdAt',
        label: '作成日',
        sortable: true,
        hidable: false,
        enable: true,
        searchable: true,
        class: 'sticky-column left-sticky-column-1',
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.startDatetimeDisplay(value);
        },
      });
      fields.push({
        key: 'action',
        label: '',
        sortable: false,
        hidable: false,
        enable: true,
        searchable: true,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 150 },
      });
    }
    return {
      fields: fields,
      currentPage: 1,
      perPage: 50,
      selectAll: false,
      TABS,
      currentTab: currentTab,
      currentNotification: null,
      popupTypeCustomHeader: true,
      filter: null,
      footFilters: {},
    };
  },
  computed: {
    currentNotifications() {
      switch (this.currentTab) {
        case this.TABS.UNPUBLISHED_TAB:
          return this.getUnpublishedNotifications;
        case this.TABS.PUBLISHING_TAB:
          return this.getPublishingNotifications;
        case this.TABS.ARCHIVED_TAB:
          return this.getArchivedNotifications;
        default:
          return this.getPublishingNotifications;
      }
    },
    resources() {
      return this.currentNotifications;
    },
    resourcesFiltered() {
      return resourcesFiltered(this.resources, this.fields, this.footFilters);
    },
    tableFootOptions() {
      return tableFootOptions(this.resources, this.fields);
    },
    showCreationButton() {
      return this.hasAdminPrivilege && this.currentTab != this.TABS.ARCHIVED_TAB;
    },
    baseIndex() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    capIndex() {
      return Math.min(this.baseIndex + this.perPage - 1, this.totalNotifications);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.totalNotifications > this.currentPage * this.perPage;
    },
    customHeaders() {
      return this.fields.filter((field) => field.hidable == true);
    },
    totalNotifications() {
      switch (this.currentTab) {
        case this.TABS.UNPUBLISHED_TAB:
          return this.totalUnpublishedNotifications;
        case this.TABS.PUBLISHING_TAB:
          return this.totalPublishingNotifications;
        case this.TABS.ARCHIVED_TAB:
          return this.totalArchivedNotifications;
        default:
          return this.totalPublishingNotifications;
      }
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    ...mapState(['notification']),
    ...mapGetters('notification', [
      'getNotificationById',
      'getUnpublishedNotifications',
      'getPublishingNotifications',
      'getArchivedNotifications',
      'totalUnpublishedNotifications',
      'totalPublishingNotifications',
      'totalArchivedNotifications',
    ]),
    ...mapGetters('role', ['hasAdminPrivilege']),
  },
  mounted() {
    EventBus.$on('SESSION_RESTORED', this.eventHandler);
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch('notification/fetchPublishingNotifications', 'publishing').then(() => {
      next();
    });
    if (store.getters['role/hasAdminPrivilege']) {
      store.dispatch('notification/fetchUnpublishedNotifications', 'unpublished');
      store.dispatch('notification/fetchArchivedNotifications', 'archived');
    }
  },
  beforeDestroy() {
    EventBus.$off('SESSION_RESTORED', this.eventHandler);
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateTableHeight();
      updateStickyColumnsAndMinWidth({ leftColumns: 1, rightColumns: 1 });
    },
    selectTab(tab) {
      this.$logger.debug('Select Tab:' + tab);
      this.currentTab = tab;
    },
    displayColumns() {
      this.$logger.debug('Display Columns for Notifications');
      this.popupTypeCustomHeader = true;
      this.$refs['popup_holder'].show();
    },
    startDatetimeDisplay(field) {
      return basicDatetime(field);
    },
    postPeriodDatetime(startDate, endDate) {
      return basicDate(startDate) + ' - ' + basicDate(endDate);
    },
    recipientsDisplay(recipientIds) {
      return basicRecipientDisplay(recipientIds);
    },
    importanceDisplay(importance) {
      return importance ? '重要' : '―';
    },
    createNewNotification() {
      this.$router.push({ name: 'notification-add' });
    },
    editCurrentNotification(id) {
      this.$logger.debug('Edit Notification with Id: ' + id);
      this.currentNotification = this.getNotificationById(id);

      this.$router.push({ name: 'notification-id-edit', params: { id } });
    },
    deleteCurrentNotification(id) {
      this.$logger.debug('Want to delete Notification with Id: ' + id);
      this.popupTypeCustomHeader = false;
      this.currentNotification = this.getNotificationById(id);
      this.$refs['popup_holder'].show();
    },
    showCurrentNotification(id) {
      this.$logger.debug('Show Notification with Id: ' + id);
      this.currentNotification = this.getNotificationById(id);

      this.$router.push({ name: 'notification-id-detail', params: { id } });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');

      if (!this.popupTypeCustomHeader && this.currentNotification) {
        this.$logger.debug('Deleted Notification with Id: ' + this.currentNotification.id);
        this.deleteNotification(this.currentNotification.id).then(() => {
          this.fetchPublishingNotifications('publishing');
          this.fetchUnpublishedNotifications('unpublished');
          this.fetchArchivedNotifications('archived');
        });
      }
    },
    popupRejected() {
      this.$logger.debug('Popup cancelled');
    },
    goToPreviousPage() {
      this.selectAll = false;
      this.currentPage--;
    },
    goToNextPage() {
      this.selectAll = false;
      this.currentPage++;
    },
    eventHandler(payload) {
      if (payload.hasAdminPrivilege) {
        if (this.fields.filter((item) => item.key === 'startDatetime').length == 0) {
          this.fields.unshift({
            key: 'createdAt',
            label: '作成日',
            sortable: true,
            hidable: false,
            enable: true,
            searchable: true,
            class: 'sticky-column left-sticky-column-1',
            thAttr: { width: 150 },
          });
        }
        if (this.fields.filter((item) => item.key === 'action').length == 0) {
          this.fields.push({
            key: 'action',
            label: '',
            sortable: false,
            hidable: false,
            enable: true,
            searchable: true,
            class: 'sticky-column right-sticky-column-1',
            thAttr: { width: 150 },
          });
        }
      }
    },
    ...mapActions('notification', [
      'fetchPublishingNotifications',
      'fetchUnpublishedNotifications',
      'fetchArchivedNotifications',
      'deleteNotification',
    ]),
  },
};
</script>

<style scoped>
.nav-cursor {
  cursor: pointer;
}
.btn-sm {
  margin-left: 0px;
}
.btn-gray {
  margin-bottom: 5px;
}
.btn-gray-with-top {
  margin-top: 10px;
}
.item-count {
  padding: 0;
  font-size: 10px;
}
.custom-control-label {
  font-weight: normal;
}
.pagination-footer {
  margin-top: 20px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.hyper-text-right {
  margin-left: 20px;
}
.form-group {
  margin-top: 10px;
}
.lb-red {
  color: red;
}
</style>
